const NAV_CHANGED = 'nav-config-changed'

export function emitNavChanged(): void {
  try {
    window.dispatchEvent(new CustomEvent(NAV_CHANGED))
  } catch {}
}

export function subscribeNavChanged(handler: () => void): () => void {
  const fn = () => handler()
  try {
    window.addEventListener(NAV_CHANGED, fn)
    return () => window.removeEventListener(NAV_CHANGED, fn)
  } catch {
    return () => {}
  }
}

